import { IItem } from '@bimser/core';
import { GetIconComponent } from '@bimser/icons';
import classNames from 'classnames/bind';
import * as React from 'react';
import BCBadge from '../../BCBadge';
import Styles from '../assets/style.scss';
const cx = classNames.bind(Styles);

const badgeStyle: React.CSSProperties = {
	marginLeft: '5px'
};
const bcIconStyles: React.CSSProperties = {
	verticalAlign: 'inherit',
	lineHeight: '100%'
};

const MenuItem = (props: {
	item: IItem;
	showEmptyIconSpace?: boolean;
	showShortcutSpace?: boolean;
	textCustomStyles?: React.CSSProperties;
}) => {
	const renderIcon = () => {
		if (props.item.icon) {
			return GetIconComponent(props.item.icon, { style: bcIconStyles });
		} else {
			if (props.showEmptyIconSpace) {
				return (
					<div
						className="bcIcon"
						style={bcIconStyles}
					/>
				);
			}
		}
	};

	const renderText = () => {
		if (!props.item.text) {
			return null;
		}

		return (
			<span
				className="ant-menu-text-custom"
				title={props.item.text}
				style={props.textCustomStyles}
			>
				{props.item.text}
			</span>
		);
	};

	const renderShortcut = () => {
		if (props.item.shortCut || props.showShortcutSpace) {
			const classNames = cx({
				menuItemShortcutText: true,
				shortCutPlaceholder: !props.item.shortCut
			});

			return (
				<span className={classNames + ' menuItemShortcutText'}>
					{'(' + props.item.shortCut + ')'}
				</span>
			);
		}
	};

	const renderBadge = () => {
		if (!props.item.badge) {
			return null;
		}

		return (
			<BCBadge
				{...props.item.badge}
				style={badgeStyle}
			/>
		);
	};

	return (
		<>
			{renderIcon()}
			{renderText()}
			{props.item.shortCut && renderShortcut()}
			{renderBadge()}
		</>
	);
};
export default MenuItem;
